{
  "CHAT_LIST": {
    "LOADING": "Notiek sarunu iegūšana",
    "LOAD_MORE_CONVERSATIONS": "Ielādēt vairāk sarunu",
    "EOF": "Visas sarunas ir ielādētas 🎉",
    "LIST": {
      "404": "Šajā grupā nav aktīvu sarunu."
    },
    "FAILED_TO_SEND": "Neizdevās nosūtīt",
    "TAB_HEADING": "Sarunas",
    "MENTION_HEADING": "Pieminēšanas",
    "UNATTENDED_HEADING": "Bez uzraudzības",
    "SEARCH": {
      "INPUT": "Meklēt Cilvēkus, Tērzēšanas, Saglabātās Atbildes.."
    },
    "FILTER_ALL": "Visi",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Mani",
      "unassigned": "Nepiešķirtie",
      "all": "Visi"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Atvērt"
      },
      "resolved": {
        "TEXT": "Atrisināts"
      },
      "pending": {
        "TEXT": "Gaida"
      },
      "snoozed": {
        "TEXT": "Atlikts"
      },
      "all": {
        "TEXT": "Visi"
      }
    },
    "VIEW_FILTER": "Apskatīt",
    "SORT_TOOLTIP_LABEL": "Šķirot sarunas",
    "CHAT_SORT": {
      "STATUS": "Statuss",
      "ORDER_BY": "Sakārtot pēc"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": {
        "LATEST": "Izveidots",
        "OLDEST": "Izveidots plkst:"
      },
      "LAST_ACTIVITY": {
        "NOT_ACTIVE": "Pēdējā darbība:",
        "ACTIVE": "Pēdējā darbība"
      }
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Pēdējā darbība: Vecākā vispirms"
      },
      "last_activity_at_desc": {
        "TEXT": "Pēdējā darbība: Jaunākā vispirms"
      },
      "created_at_desc": {
        "TEXT": "Izveidots: Jaunākā vispirms"
      },
      "created_at_asc": {
        "TEXT": "Izveidots: Vecākā vispirms"
      },
      "priority_desc": {
        "TEXT": "Prioritāte: Augstākā vispirms"
      },
      "priority_asc": {
        "TEXT": "Prioritāte: Zemākā vispirms"
      },
      "waiting_since_asc": {
        "TEXT": "Gaida atbildi: Garākā vispirms"
      },
      "waiting_since_desc": {
        "TEXT": "Gaida atbildi: Īsākā vispirms"
      },
      "priority_desc_created_at_asc": {
        "TEXT": "Priority: Highest first, Created: Oldest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Attēla ziņojums"
      },
      "audio": {
        "CONTENT": "Audio ziņojums"
      },
      "video": {
        "CONTENT": "Video ziņojums"
      },
      "file": {
        "CONTENT": "Faila pielikums"
      },
      "location": {
        "CONTENT": "Atrašanās vieta"
      },
      "ig_reel": {
        "CONTENT": "Instagram Spole"
      },
      "fallback": {
        "CONTENT": "ir kopīgojis URL"
      },
      "contact": {
        "CONTENT": "Koplietota kontaktpersona"
      },
      "embed": {
        "CONTENT": "Embedded content"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Šķirot sarunu",
      "DROPDOWN_TITLE": "Kārtot pēc",
      "ITEMS": {
        "LATEST": {
          "NAME": "Pēdējā aktivitāte plkst",
          "LABEL": "Pēdējā darbība"
        },
        "CREATED_AT": {
          "NAME": "Izveidots plkst",
          "LABEL": "Izveidots plkst"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Pēdējā lietotāja ziņa plkst",
          "LABEL": "Pēdējā ziņa"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Saņemts pa e-pastu",
    "VIEW_TWEET_IN_TWITTER": "Skatīt tvītu pakalpojumā Twitter",
    "REPLY_TO_TWEET": "Atbildēt uz šo tvītu",
    "LINK_TO_STORY": "Doties uz instagram stāstu",
    "SENT": "Veiksmīgi nosūtīts",
    "READ": "Izlasīts veiksmīgi",
    "DELIVERED": "Piegādāts veiksmīgi",
    "NO_MESSAGES": "Nav Ziņojumu",
    "NO_CONTENT": "Saturs nav pieejams",
    "HIDE_QUOTED_TEXT": "Paslēpt Citēto Tekstu",
    "SHOW_QUOTED_TEXT": "Rādīt Citēto Tekstu",
    "MESSAGE_READ": "Lasīt",
    "SENDING": "Sūtīšana",
    "UNREAD_COUNT_OVERFLOW": "9+"
  }
}
